/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-03 13:36:04
 * @Description:
 */
import { initDayjs } from './utils/date';
import { hookLog } from './utils/debug';
import { initGA } from './utils/gtag';
import { initOpentelemetry } from './utils/opentelemetry';
import { getParamsFromQuery } from './utils/query';
import { initSentry } from './utils/sentry';
import {
  cookie,
  COOKIE_FIRST_AUTH_TOKEN,
  COOKIE_KREDIVO_USER_ID,
  local,
  LOCAL_TOKEN,
} from './utils/store';
import { setDefaultColorPlateToRoot } from './utils/theme';

setDefaultColorPlateToRoot();
hookLog();
initDayjs();

const { kredivoUserId: kredivoUserIdFromQuery, firstAuthToken } =
  getParamsFromQuery();
// jumping back from 3rd party page, kredivoUserId is not in query, instead, it's stored in localStorage
const kredivoUserId =
  kredivoUserIdFromQuery || cookie.get(COOKIE_KREDIVO_USER_ID) || '';

if (kredivoUserId) {
  initSentry(kredivoUserId);
  initOpentelemetry(kredivoUserId);
  initGA(kredivoUserId);
}

if (kredivoUserIdFromQuery) {
  cookie.set(COOKIE_KREDIVO_USER_ID, kredivoUserIdFromQuery);
  local.remove(LOCAL_TOKEN);
}

if (firstAuthToken) {
  cookie.set(COOKIE_FIRST_AUTH_TOKEN, firstAuthToken);
}
